module.exports = __webpack_public_path__ + "static/img/logistics-h5-1.57c2aeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logistics-h5-1.png
// module id = Sqps
// module chunks = 34